/** Train numbers with 5+ digits identify Fluo-branded regional services.
 *  Numbers with 4 digits or fewer are TGV (SNCF / DB / ICE) and must NOT
 *  display the Fluo wordmark — they keep a neutral "Train" pictogram. */
export const isFluoBranded = (number) => {
  if (number == null) return false;
  const m = String(number).match(/\d+/);
  return !!(m && m[0].length >= 5);
};
